import React from 'react';
import PropTypes from 'prop-types';
import DirectionsCarIcon from '@mui/icons-material/DirectionsCar';
import SearchFilterUtil from 'lib/SearchFilterUtil';
import { ZERO_TO_SIX_PLUS_OPTIONS_MAX, ZERO_TO_SIX_PLUS_OPTIONS_MIN } from 'constants/filterOptions';
import useFilterStore from 'zustandStore/useFilterStore';
import RpBasicRangeFilter from 'components/commons/RpBasicRangeFilter';

const CarFilter = React.memo(function CarFilter(props) {
    const cars = useFilterStore(state => state.filters[props.comparableType].cars);
    const setFilters = useFilterStore(state => state.setFilters);

    return (
        <RpBasicRangeFilter
            label="Car"
            displayValue={SearchFilterUtil.formatBedBathCarRangeDisplay(cars?.min, cars?.max)}
            active={!!(cars?.min || cars?.max)}
            minOptions={ZERO_TO_SIX_PLUS_OPTIONS_MIN}
            maxOptions={ZERO_TO_SIX_PLUS_OPTIONS_MAX}
            minValue={cars?.min}
            maxValue={cars?.max}
            onChange={({ min, max }) => setFilters(props.comparableType, { cars: { min: min.value, max: max.value } })}
            isDropdown={props.isDropdown}
            icon={DirectionsCarIcon}
        />
    );
});

CarFilter.propTypes = {
    comparableType: PropTypes.string.isRequired,
    isDropdown: PropTypes.bool
};

export default CarFilter;
